export default "__VITE_ASSET__97ffafce__"